import { render, staticRenderFns } from "./EmptyAction.vue?vue&type=template&id=70d8d02c&"
import script from "./EmptyAction.vue?vue&type=script&lang=js&"
export * from "./EmptyAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports